module.exports = __webpack_public_path__ + "img/thumbp2p2.2133fd47.png";